import { render, staticRenderFns } from "./HomeTestimonialSlider.vue?vue&type=template&id=4706a75d&scoped=true&"
import script from "./HomeTestimonialSlider.vue?vue&type=script&lang=js&"
export * from "./HomeTestimonialSlider.vue?vue&type=script&lang=js&"
import style0 from "./HomeTestimonialSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeTestimonialSlider.vue?vue&type=style&index=1&id=4706a75d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706a75d",
  null
  
)

export default component.exports